import { LanguageEnum } from "jadro-pico/enums/common/LanguageEnum";
import { defineResources } from "./defineResources";

export const OfflineQueueResources = defineResources({
  [LanguageEnum.CS]: {
    submitFailed: "Odeslaný požadavek se nepodařilo zpracovat",
  },
  [LanguageEnum.EN]: {
    submitFailed: "A submitted request could not be processed",
  },
});
